<template>
  <v-dialog
    v-model="opened"
    light
    persistent
    max-width="310"
  >
    <v-card>
      <v-card-title class="headline">
        Copier le fichier
      </v-card-title>
      <v-divider />

      <v-card-text class="mt-3">
        <v-form
          ref="form"
          v-model="validForm"
          lazy-validation
          @submit.prevent=""
        >
          <v-text-field
            ref="copyFileNameField"
            v-model="filename"
            label="File Name *"
            required
            placeholder="File Name"
            color="info"
            :rules="[rules.required]"
          />

          <v-select
            v-if="store.getters.workspaces.length > 1 || writableWorkspaces.length > 1"
            v-model="workspaceToCopy"
            color="info"
            menu-props="light"
            item-color="info"
            :items="writableWorkspaces"
            item-text="name"
            item-value="code"
          />
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="!workspaceToCopy"
          color="success"
          small
          @click="copyFile"
        >
          Copie
        </v-btn>
        <v-btn
          color="info"
          small
          @click="closeOnClickOutside"
        >
          Annuler
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- MoveTo pop up --->
    <MoveTo ref="moveToPopup" :close-parent="close" />
  </v-dialog>
</template>

<script setup>
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import MoveTo from './MoveTo.vue';

import { EventBus } from '../../mixins';

const store = useStore();

const item = ref(null);

const opened = ref(false); // If dialog is opened or not

const validForm = ref(false);

const filename = ref('');

const form = ref(null);

const rules = reactive({ required: v => !!v || 'Required' });

const moveToPopup = ref(null);

const copyFileNameField = ref(null);

// eslint-disable-next-line arrow-body-style
const writableWorkspaces = computed(() => {
  // if (store.getters.workspaceWritable.length === 1) {
  //   workspaceToCopy.value = store.getters.workspaceWritable[0].code;
  // }
  return store.getters.workspaceWritable;
});

const workspaceToCopy = ref(store.getters.workspaceWritable.length === 1 ? store.getters.workspaceWritable[0].code : null);

const copyFile = () => {
  if (form.value.validate()) {
    const selectedItem = {
      ...item.value,
      wtitle: filename.value,
      workspace: workspaceToCopy.value,
      copy: true
    };

    moveToPopup.value.open(selectedItem);
  }
};

const open = newItem => {
  // Disables scroll on the page
  document.documentElement.style.overflow = 'hidden';

  // Opens dialog box
  opened.value = true;

  // Set's the directory where the folder will be created
  item.value = newItem;
  filename.value = `${item.value.wtitle}(Copy)`;

  setTimeout(() => copyFileNameField.value.$el.getElementsByTagName('input')[0].focus(), 300);
};

// eslint-disable-next-line no-undef
defineExpose({ open });

const close = () => {
  document.documentElement.style.overflow = 'auto';
  opened.value = false;
};

const closeOnClickOutside = () => {
  if (opened.value) {
    EventBus.$emit('unselectItem');
    close();
  }
};

</script>

<style lang="scss">

    .v-card__actions {
        height: 50px;
    }

</style>
